export default __webpack_public_path__ + "static/media/main_loading.62ba2243.gif";